import React from 'react'
import PFTLListTable from './Components/PFTLListTable'
import AddItemBtn from "Common/Custom/AddItemBtn";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";

const PFTLList = () => {
  return (
    <PageBody
      card={true}
      headerchildren={
        <>
          <HeadingOne>Package Food Type List</HeadingOne>
          <AddItemBtn url="add-package-food-type-limit" title="Create" />
        </>
      }>

      {/* Table section */}
      <div className="col-12">
        <PFTLListTable />
      </div>
    </PageBody>
  );
};

export default PFTLList;
